<template>
  <div class="table-form form">
    <el-form :model="form" ref="ruleForm" label-width="200px" class="ruleForm">
      <el-form-item label="法定代表人/执行事务合伙人(委派代表)">
        <el-input v-model="form.legalName" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="联系电话">
        <el-input v-model="form.legalTel" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="联系人">
        <el-input v-model="form.linkmanName" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="联系电话">
        <el-input v-model="form.linkmanTel" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="认缴出资额(万元)">
        <el-input v-model="form.capitalAdmitted" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="实缴出资额(万元)">
        <el-input v-model="form.capitalPaid" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="资产总额(万元)">
        <el-input v-model="form.capitalTotal" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="累计纳税金额(万元)">
        <el-input v-model="form.taxTotal" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="企业员工数量(不包含兼职)">
        <el-input v-model="form.staffCount" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="实际办公地址">
        <el-input v-model="form.realAddress" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="托管机构名称">
        <el-input v-model="form.trusteeInstutition" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="投资者人数(人)">
        <el-input v-model="form.investorCount" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="机构投资者人数(人)">
        <el-input v-model="form.instInvestorCount" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="自然人投资者人数(人)">
        <el-input v-model="form.natureInvestorCount" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="是否已完成中基协备案">
        <el-select v-model="form.associtionRegisted" placeholder="请选择" @change="changeRegister" :disabled="disable">
          <el-option
            :value="item.value"
            :label="item.label"
            v-for="(item,index) of options"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <!--已登记-->
      <el-form-item label="备案时间" v-if="isRegister">
        <el-date-picker
          v-model="form.registedTime"
          type="date"
          placeholder="选择日期"
          :disabled="disable"
          value-format="yyyy-MM-dd"
          
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="备案编号" v-if="isRegister" class="register">
        <el-input v-model="form.registedNo" :disabled="disable"></el-input>
      </el-form-item>
      <!--未登记 未办理-->
      <el-form-item label="是否办理中" v-if="!isRegister">
        <el-select v-model="form.isRegisting" placeholder="请选择" @change="changeTransact" :disabled="disable">
          <el-option
            :value="item.value"
            :label="item.label"
            v-for="(item,index) of options"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <!--  -->
      <el-form-item label="备案具体进展" v-if="!isRegister&&transact">
        <el-input v-model="form.registeProgress" :disabled="disable"></el-input>
      </el-form-item>
      <el-form-item label="预计完成时间" v-if="!isRegister&&transact" :disabled="disable">
        <el-date-picker
          v-model="form.registePlanTime"
          type="date"
          placeholder="选择日期"
          :disabled="disable"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      <!-- <el-form-item label="托管机构名称">
        <el-input v-model="form.trusteeInstitution" :disabled="disable"></el-input>
      </el-form-item> -->
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Object,
      default: function() {
        return {};
      }
    },

    disable: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      // 是否已完成中基协登记
      isRegister: false,
      // 是否办理中
      transact: false,
      form: {
        associtionRegisted: true,
        capitalPaid: "",
        capitalRegisted: "",
        capitalTotal: "",
        createdTime: "",
        detailDataFileOrginName: "",
        detailDataFileStorePath: "",
        isRegisting: false,
        legalName: "",
        legalTel: "",
        linkmanName: "",
        linkmanTel: "",
        quarterReportName: "",
        realAddress: "",
        registePlanTime: "",
        registeProgress: "",
        registedNo: "",
        registedTime: "",
        reportCode: "",
        staffCount: "",
        taxTotal: "",
        trusteeInstitution: "",
        userInstitutionCode: ""
      },
      options: [
        {
          label: "是",
          value: true
        },
        {
          label: "否",
          value: false
        }
      ]
    };
  },

  mounted() {
    this.getData(this.tableData);
  },

  methods: {
    getData(val) {
      if (!Object.keys(val).length) return;
   
      if (val.associtionRegisted) {
        this.isRegister = true;
      } else {
        this.isRegister = false;
        this.transact = false;
      }

      if (val.isRegisting) {
        this.transact = true;
      }

      val.registedTime = val.registedTime
        ? this.$moment(val.registedTime).format("YYYY-MM-DD")
        : this.$moment(new Date()).format("YYYY-MM-DD");
      val.registePlanTime = val.registePlanTime
        ? this.$moment(val.registePlanTime).format("YYYY-MM-DD")
        : this.$moment(new Date()).format("YYYY-MM-DD");
      this.form = this.$lodash.cloneDeep(val);
    },

    changeTransact(val) {
      this.transact = val;
    },

    changeRegister(val) {
      this.isRegister = val;
    }
  },

  watch: {
    tableData: {
      handler(newValue) {
        this.getData(this.tableData);
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.register {
  /* border-bottom: 1px solid #e1e1e1 !important; */
}

.form {
  margin-top: 20px;
}
</style>
